import { render, staticRenderFns } from "./adminRebateList.vue?vue&type=template&id=b740486e&"
import script from "./adminRebateList.vue?vue&type=script&lang=js&"
export * from "./adminRebateList.vue?vue&type=script&lang=js&"
import style0 from "./adminRebateList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports